<template>
    <v-col cols="12" lg="6">
        <span class="headline">Korisnici</span>
        <bit-page :breadcrumbs="breadcrumbs"></bit-page>
        <v-row align="center" class="white mt-3 pa-3" no-gutters>
            <span class="title green--text text--darken-3">Meni</span>
            <v-col class="d-flex mb-3" cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col class="d-flex mt-3" cols="12">
                <v-btn depressed small tile color="primary" :to="{name: 'korisnici-roles-create'}">Dodaj novu rolu</v-btn>
            </v-col>
            <v-col class="d-flex mt-3" cols="12">
                <v-data-table
                        class="mt-4"
                        hide-default-footer
                        style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                        :headers="headers"
                        :items="items"
                ></v-data-table>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
	import bitPage from "../../../components/layout/page";

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Meni',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'E-Mail', value: 'email'},
				{text: 'Preview', value: 'preview'},
				{text: 'Role', value: 'role'},
				{text: 'Option', value: 'option'},
			],
			items: []
		}),
	}
</script>
